import { render, staticRenderFns } from "./DashboardAlbaranesResumen.vue?vue&type=template&id=46560c34&scoped=true&lang=pug"
import script from "./DashboardAlbaranesResumen.vue?vue&type=script&lang=js"
export * from "./DashboardAlbaranesResumen.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlbaranesResumen.vue?vue&type=style&index=0&id=46560c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46560c34",
  null
  
)

export default component.exports